import {IDatasetTotal} from "components/dashboard/dataset-table/DatasetTable";
import React, {CSSProperties, ReactNode} from 'react';
import {TitleOverrideAndDescriptionTemplate} from "components/templates/DataTableCellTemplates";
import {ComponentConfigDefault} from "models/dataset-models";
import {ChronoUnitLegacy, dateToReadableString} from "utils/time-utils";
import {Tooltip} from "primereact/tooltip";

type DatasetTableDefaultProps = {
    data: Array<any>
    config?: ComponentConfigDefault
    datasetsArray: Array<any>

    getCellStyle: (date: string, obj: any) => CSSProperties | undefined
    totals: IDatasetTotal[]
}

const lookUpWidth: Record<ChronoUnitLegacy, string> = {
    "YEARS": "45px",
    "MONTHS": "60px",
    "WEEKS": "70px",
    "DAYS": "80px",
    "HOURS": "95px",
    "MINUTES": "115px",
    "SECONDS": "130px"
}

const DatasetTableDefault = ({config, data, datasetsArray, getCellStyle, totals}: DatasetTableDefaultProps) => {
    const showTotal = datasetsArray.some(obj => obj.showTotal)
    const ColumnHeader = () => {
        return <tr>
            {!config?.hideDateColumn &&
                <th style={{
                    padding: "2px 8px",
                    width: lookUpWidth[config?.dateFormat || ChronoUnitLegacy.MINUTES]
                }}>
                    Date
                </th>
            }
            {datasetsArray?.map((col: any, i: number) => {
                return <th key={i}
                           style={{padding: "2px 8px"}}
                >{TitleOverrideAndDescriptionTemplate({
                    description: col.description,
                    title: col.title,
                    overriddenTitle: col.overriddenTitle,
                    unit: col.unit
                }, 2)}
                </th>
            })
            }
        </tr>

    }

    const ColumnFooter = () => {
        return (
            <tr>
                <th scope="row"></th>
                {totals.length > 0 ? totals.map(obj => {
                    if(obj.value){
                        return <td className="value-class" key={obj.identifier}><Tooltip target=".value-tooltip" /><span className="value-tooltip" data-pr-tooltip={`${obj.tooltip}`} >{obj.value}</span></td>
                    } else {
                        return <td className="value-class" key={obj.identifier}></td>
                    }
                }) :  <td className="value-class"></td> }
            </tr>
        )
    }

    const dateBody = (date: string): string => {
        const dateDate = new Date(date);
        const dateFormat = config?.dateFormat || "MINUTES";
        return dateToReadableString(dateDate, dateFormat as ChronoUnitLegacy);
    }

    const columnBody = data.map((obj: any, index: number): ReactNode => {
            if (config?.transposed) {
                return (<tr key={index}></tr>)
            }
            return (<tr key={index}>
                {!config?.hideDateColumn &&
                    <td style={{
                        whiteSpace: "nowrap",
                        padding: "2px 8px"
                    }}>
                        {dateBody(obj.date)}
                    </td>
                }
                {Object.entries(obj).map(([key, value], index) => {
                    if (key !== "date") {
                        return <td key={index} className={"value-class"} style={getCellStyle(key, value)}>
                            {value || value === 0 ?
                                datasetsArray[index].decimalPlaces != null ?
                                    <>{(value as number).toFixed(datasetsArray[index].decimalPlaces)}</>
                                    :
                                    <>{(value as number).toFixed(2)}</>
                                :
                                "-"
                            }</td>
                    }
                })}
            </tr>)
        }
    )

    return <div className={"data-table-wrapper default-table"}>
        <table className={"min-table-width"}>
            <thead>
            <ColumnHeader/>
            </thead>
            <tbody>
            {columnBody}
            </tbody>
            {showTotal && (<tfoot>
            <ColumnFooter />
            </tfoot>)}
        </table>
    </div>
};

export default DatasetTableDefault;